// extracted by css-extract-rspack-plugin
export default {"social":"_9ae905d5","socialButton":"_4e575103","shareButton":"_7cbdb6d5","socialShareWrapper":"_85ec0e0b"};